import React, { useState } from 'react';

/**
 * Director (D-Node) count entry. A plain number spinner with no ceiling —
 * the fleet can hold as many directors as the customer will buy.
 *
 * While the field is being edited we hold the raw keystrokes in `draft` and
 * commit only whole numbers at or above `min`. Clamping on every keystroke
 * instead (the way NodeCountInput does) would make a count like 12
 * untypeable: the leading "1" would snap straight back to the minimum.
 * Anything still short of the minimum when focus leaves settles to `min`.
 */
export function DirectorCountInput({ value, min = 3, onChange, label = 'Director Count' }) {
  const [draft, setDraft] = useState(null); // null = mirror the committed value

  const isCommittable = (raw) => {
    if (raw.trim() === '') return false;
    const parsed = Number(raw);
    return Number.isInteger(parsed) && parsed >= min;
  };

  const handleChange = (e) => {
    const raw = e.target.value;
    setDraft(raw);
    if (isCommittable(raw)) onChange(Number(raw));
  };

  const handleBlur = () => {
    if (draft !== null && !isCommittable(draft)) onChange(min);
    setDraft(null);
  };

  return (
    <input
      type="number"
      step="1"
      min={min}
      value={draft ?? value}
      onChange={handleChange}
      onBlur={handleBlur}
      aria-label={label}
      className="input-box-narrow"
    />
  );
}
